import { maxAreaForAspect, normRot } from './orientation'

function num(value: any, fallback = 0) {
  const next = Number(value)
  return Number.isFinite(next) ? next : fallback
}

function resolveSourceDims(rec: any) {
  const crop = (rec?.edits?.crop || {}) as any
  let width = Math.max(0, Math.round(num(crop?.sourceWidth, 0) || num(rec?.editorWidth, 0) || num(rec?.width, 0)))
  let height = Math.max(0, Math.round(num(crop?.sourceHeight, 0) || num(rec?.editorHeight, 0) || num(rec?.height, 0)))
  const rotate = normRot(rec?.edits?.rotate ?? rec?.edits?.preset?.rotate ?? crop?.rot ?? 0)
  if (rotate === 90 || rotate === 270) {
    ;[width, height] = [height, width]
  }
  return { width, height }
}

export function resolveFrozenOrientation(rec: any) {
  const edits = (rec?.edits || {}) as any
  const preset = (edits?.preset || {}) as any
  const lockAR = edits?.lockAR != null ? !!edits.lockAR : true
  const orientMode = edits?.orientMode === 'manual' ? 'manual' : 'auto'
  const swapAR = edits?.swapAR != null ? !!edits.swapAR : false

  if (!lockAR) {
    return { lockAR: false, orientMode, swapAR }
  }

  const widthMm = num(preset?.size?.widthMm, 0)
  const heightMm = num(preset?.size?.heightMm, 0)
  if (!(widthMm > 0 && heightMm > 0)) {
    return { lockAR: true, orientMode, swapAR }
  }

  if (orientMode === 'manual') {
    return { lockAR: true, orientMode: 'manual' as const, swapAR }
  }

  const { width, height } = resolveSourceDims(rec)
  if (!(width > 0 && height > 0)) {
    return { lockAR: true, orientMode, swapAR }
  }

  const ar = widthMm / Math.max(0.0001, heightMm)
  const regularArea = maxAreaForAspect(width, height, ar)
  const swappedArea = maxAreaForAspect(width, height, 1 / ar)
  return {
    lockAR: true,
    orientMode: 'manual' as const,
    swapAR: swappedArea > regularArea,
  }
}
